import type { CSSProperties } from "react";
import type { InboundCall } from "@/api/client";
import { Avatar } from "@/components/Avatar";
import { Icon } from "@/components/Icon";

// Кто звонит — картинкой. Номер из базы: фото (или инициалы) и на углу
// зелёный значок трубки; незнакомый номер: сама трубка в круге. Пока звонок
// ждёт ответа, от трубки расходятся кольца (выключаются при
// prefers-reduced-motion — см. inboundCall.css).
export function CallerAvatar({
  call,
  size,
  ringing,
}: {
  call: Pick<InboundCall, "person">;
  size: number;
  ringing: boolean;
}) {
  const person = call.person;
  const style = { "--icall-av": `${size}px` } as CSSProperties;
  if (!person) {
    return (
      <span className={"icall-phone" + (ringing ? " icall-ringing" : "")} style={style} aria-hidden="true">
        <Icon name="phone" size={Math.round(size * 0.44)} strokeWidth={1.8} />
      </span>
    );
  }
  const photo = person.avatar_resume_id
    ? `/api/resume/${encodeURIComponent(person.avatar_resume_id)}/photo`
    : null;
  return (
    <span className="icall-av" style={style} aria-hidden="true">
      <Avatar name={person.name} src={photo} size={size} />
      <span className={"icall-badge" + (ringing ? " icall-ringing" : "")}>
        <Icon name="phone" size={Math.max(10, Math.round(size * 0.24))} strokeWidth={2} />
      </span>
    </span>
  );
}
